import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import type { ApiResponse } from "@/shared/api/types";
import type { PublicRecoveryPlanDTO } from "@fysaro/domain";

export const getPublicRecoveryPlan = async (planId: string): Promise<PublicRecoveryPlanDTO> => {
  const response = await api.get<ApiResponse<PublicRecoveryPlanDTO>>(
    `/recovery-plans/public/${planId}`
  );
  return unwrap(response.data);
};